module.exports = __webpack_public_path__ + "static/img/name4.d8d7b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/th/name4.png
// module id = FWB1
// module chunks = 1